export const sections = [
    // admin + system-admin sections
    {
        sectionId: 'koncerty',
        rolesList: ["admin", "system-admin"]
    },
    {
        sectionId: 'objednavky',
        rolesList: ["admin", "system-admin"]
    },
    {
        sectionId: 'produkty',
        rolesList: ["admin", "system-admin"]
    },
    {
        sectionId: 'aktuality',
        rolesList: ["admin", "system-admin", "member"]
    },
    {
        sectionId: 'recenzie',
        rolesList: ["admin", "system-admin", "member"]
    },
    {
        sectionId: 'galeria',
        rolesList: ["admin", "system-admin", "member"]
    },
    {
        sectionId: 'informacie',
        rolesList: ["admin", "system-admin"]
    },

    // system-admin sections
    {
        sectionId: 'webApp-statistiky',
        rolesList: ["system-admin"]
    },
    {
        sectionId: 'webApp-manazment',
        rolesList: ["system-admin"]
    },
]